import { createSlice } from "@reduxjs/toolkit";
import { PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS, PROPOSAL_END_CLIENT_DETAIL_PAGE_LABELS } from "../../pages/proposal-template/end-client/detail-page/ProposalEndClientDetailPage.config";


const initialState = {
    theme: 'Default',
    proposalDetailsMainPage: [
        {
            proposalDetailType: PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.BACKGROUND,
            backgroundImage: "",
            headingText: "",
            subHeadingText: PROPOSAL_END_CLIENT_DETAIL_PAGE_LABELS[PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.BACKGROUND]
        },
        {
            proposalDetailType: PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.OBJECTIVE,
            backgroundImage: "",
            headingText: "",
            subHeadingText: PROPOSAL_END_CLIENT_DETAIL_PAGE_LABELS[PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.OBJECTIVE]
        },
        {
            proposalDetailType: PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.APPROACH,
            backgroundImage: "",
            headingText: "",
            subHeadingText: PROPOSAL_END_CLIENT_DETAIL_PAGE_LABELS[PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.APPROACH]
        },
        {
            proposalDetailType: PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.TIMELINES_AND_INVESTMENT,
            backgroundImage: "",
            headingText: "",
            subHeadingText: PROPOSAL_END_CLIENT_DETAIL_PAGE_LABELS[PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.TIMELINES_AND_INVESTMENT]
        },
    ],
    background: {
        backgroundText: "",
        backgroundSupportingDocs: []
    },
    approach: {
        paragraphText: "",
        infographic: null,
        deliverables: [],
        resourceMaterials: []
    },
    timelinesAndInvestment: {
        timelinesTable: [],
        samplesTable: [],
        quotationsTable: []
    },
    objective: {
        cards: [],
        caseStudies: []
    },
    homePage: {
        homepageHeading: "",
        homePageLogoURL: null,
        homepageCollaterals: null
    },
    requestCode: null,
    salesPocEmail: null,
    isAwarded: false,
    isOnboardingComplete: false
}

export const sliceName = "ProposalTemplateEndClient"
export const ProposalTemplateEndClientSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        setInitialStateForEndClientProposal: (state, action) => {
            const { salesPoc, isAwarded, isOnboardingComplete,
                proposalDetails: {
                    theme,
                    proposalCode,
                    proposalDetailsMainPage,
                    samplePlanTables,
                    homepageCollaterals,
                    homepageCollateralShape,
                    homepageHeading,
                    clientLogo: { url: homePageLogoURL },
                    background,
                    supportingDocs,
                    timelinesTable,
                    samplePlan,
                    objective,
                    caseStudies,
                    spoc_proposal_end_client,
                    deliverables,
                    resourceMaterials,
                    approach: {
                        paragraphText: approachMainParaText,
                        infographic: { name, url: approachInfographicURL }
                    }
                }
            } = action.payload
            proposalDetailsMainPage.map((slide, index) => {
                const { proposalFourSlide: { backgroundImage: { name, url }, headingText }, proposalDetailType } = slide
                const _tempObj = {
                    proposalDetailType,
                    backgroundImage: url,
                    headingText,
                    subHeadingText: PROPOSAL_END_CLIENT_DETAIL_PAGE_LABELS[proposalDetailType]
                }
                state.proposalDetailsMainPage[index] = _tempObj
                state.requestCode = proposalCode
                state.background = {
                    backgroundText: background.backgroundText,
                    supportingDocs,
                }
                state.approach = {
                    paragraphText: approachMainParaText,
                    infographic: approachInfographicURL,
                    deliverables,
                    resourceMaterials
                }
                state.timelinesAndInvestment.timelinesTable = timelinesTable
                state.timelinesAndInvestment.samplesTable = samplePlanTables
                state.timelinesAndInvestment.quotationsTable = (spoc_proposal_end_client?.proposalCode === state.requestCode) ? spoc_proposal_end_client?.investmentTableList : []
                state.objective = {
                    cards: objective.cards,
                    caseStudies
                }
                state.homePage = {
                    homepageHeading,
                    homePageLogoURL,
                    homepageCollaterals
                }
                state.homepageCollateralShape = homepageCollateralShape
                state.salesPoc = salesPoc
                state.isAwarded = isAwarded
                state.isOnboardingComplete = isOnboardingComplete
                state.theme = theme
            })
        }
    }
})

export const selectProposalFourSlideDetails = state => state[sliceName].proposalDetailsMainPage
export const selectBackgroundDetails = state => state[sliceName].background
export const selectApproachContent = state => state[sliceName].approach
export const selectTimelinesAndInvestmentData = state => state[sliceName].timelinesAndInvestment
export const selectObjectiveDetails = state => state[sliceName].objective
export const selectHomePageDetails = state => state[sliceName].homePage
export const selectHomePageCollateralShape = state => state[sliceName].homepageCollateralShape
export const selectSalesPocEmail = state => state[sliceName].salesPoc
export const selectEndClientCompleteData = state => state[sliceName]
export const selectRequestCode = state => state[sliceName].requestCode
export const selectIsAwarded = state => state[sliceName].isAwarded
export const selectTheme = state => state[sliceName].theme
export const selectIsOnboardingComplete = state => state[sliceName].isOnboardingComplete
export const selectHeadingTextsForAllSection = state => {
    let _temp = {}
    state[sliceName].proposalDetailsMainPage.map(section => {
        _temp[section.proposalDetailType] = section.headingText
    })
    return _temp
}
export const { setInitialStateForEndClientProposal } = ProposalTemplateEndClientSlice.actions

export default ProposalTemplateEndClientSlice.reducer